













import { Vue, Component } from 'vue-property-decorator';
import CrearSolicitudModal from '@/pantallas/Solicitudes/CrearSolicitudModal.vue';

@Component({
  components: {
    CrearSolicitudModal,
  },
})
export default class ButtonCrearSolicitud extends Vue {
  mostrarModalCrear: boolean = false;
  handleClick() {
    this.mostrarModalCrear = true;
  }
  handleCierreModalCrear() {
    this.mostrarModalCrear = false;
  }
}
